import styled from "styled-components";
import { Link } from "react-router-dom";

const UnstyledLink = styled(Link)`
  text-decoration: inherit;
  color: inherit;
`;

export { UnstyledLink };
